window.onload = function () {
	console.log("test1");

	const currentPath = window.location.pathname;
	console.log("current path", currentPath);
	const match = currentPath.match(/collections\/([^\/]+)/);

	if (!match || !match[1]) {
		console.log("No category in URL");
		return;
	}

	const currentCategory = match[1];
	console.log("currentCategory", currentCategory);

	fetch("/cdn/shop/t/2/assets/categories.json") // Adjust if needed
		.then((response) => response.json())
		.then((data) => {
			let matchedParent = null;
			let matchedSub = null;
			let subParent = null;

			data.forEach((cat) => {
				// Check if currentCategory matches the parent
				if (cat.url === currentCategory) {
					matchedParent = cat;
					matchedSub = null; // No sub matched
					return; // Exit early for this iteration
				}

				// Check if it matches a subcategory
				console.log("cat", cat);

				const childMatch = cat.children?.find((sub) => sub.url === currentCategory);
				if (childMatch) {
					console.log("childMatch", childMatch);
					subParent = childMatch;
					// matchedParent = cat;
				}
			});

			if (matchedParent) {
				console.log(matchedParent);
				hideFilter("product", "wine_family");
				hideFilter("product", "grapes");
				hideFilter("product", "vineyard_regions");

				hideCheeseFilters();
			} else {
				console.log("no matching parent");
			}

			if (matchedSub) {
				console.log("Matched subcategory:", matchedSub);
				console.log("Parent category:", matchedParent);
				// Do something when it's a subcategory

				// find the html as below that is  filter-filter.p.m.product.sub_category

				// <details class="filter disclosure" id="filter-filter.p.m.product.sub_category" data-type="list" open="">
				// hide the parent which is a <details-disclosure> tag

				const filterElement = document.querySelector("#filter-filter\\.p\\.m\\.product\\.sub_category");
				if (filterElement && filterElement.parentElement) {
					filterElement.parentElement.style.display = "none";
				}

				if (matchedSub != "wine") {
					hideFilter("product", "wine_family");
					hideFilter("product", "grapes");
					hideFilter("product", "vineyard_regions");
				}

				if (matchedSub != "cheese") {
					hideCheeseFilters();
				}
			} else {
				console.log("Not a subcategory");

				// if collection does not contain wine, hide the wine filters.
				if (!currentPath.includes("wine")) {
					hideFilter("product", "wine_family");
					hideFilter("product", "grapes");
					hideFilter("product", "vineyard_regions");

					// Hide Cheese filters
				}

				if (!currentPath.includes("cheese")) {
					hideCheeseFilters();
				}
			}

			const allowedMatches = ["alba", "bobs-red-mill", "brand3", "brand4"];

			if (!allowedMatches.some((v) => match.includes(v))) {
				// hideFilter("custom", "main_category");
			}
			hideSingleFilter("custom", "main_category");
		})
		.catch((error) => console.error("Error loading JSON:", error));
};

function hideFilter(namespace, metafield) {
	try {
		const filterElement = document.querySelector("#filter-filter\\.p\\.m\\." + namespace + "\\." + metafield + "");
		if (filterElement) {
			if (filterElement.parentElement) {
				filterElement.parentElement.style.display = "none";
			} else {
				console.warn("something for hiding did not work", filterElement, namespace, metafield);
			}
		}
	} catch (error) {
		console.error(error);
	}
}

function hideCheeseFilters() {
	console.log("dont show cheese filters");
	hideFilter("product", "classification");
	hideFilter("product", "flavor");
	hideFilter("product", "usage");
}

function hideWineFilters() {
	console.log("dont show wine filters");
	hideFilter("product", "wine_family");
	hideFilter("product", "grapes");
	hideFilter("product", "vineyard_regions");
}

function hideSingleFilter(namespace, metafield) {
	try {
		// Build the selector, same style as your existing function
		const selector = "#filter-filter\\.p\\.m\\." + namespace + "\\." + metafield;
		const filterElement = document.querySelector(selector);

		if (!filterElement) return;
		else console.log("Found filter element for single check:", selector);

		// Find the UL list inside the filter
		const ul = filterElement.querySelector("ul[role='list']");

		if (!ul) return;

		// Count li elements
		const items = ul.querySelectorAll("li");

		// Hide filter if only 1 item exists
		if (items.length <= 1) {
			filterElement.style.display = "none";
		}
	} catch (error) {
		console.error(error);
	}
}
